export default __webpack_public_path__ + "media/images/tenant/timeline/step_2-229e9f38dde7767bab0b002af5f85fb5.webp";